import { render, staticRenderFns } from "./groups-top-bar.vue?vue&type=template&id=df174e74&"
import script from "./groups-top-bar.vue?vue&type=script&lang=js&"
export * from "./groups-top-bar.vue?vue&type=script&lang=js&"
import style0 from "./groups-top-bar.vue?vue&type=style&index=0&id=df174e74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports